"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeChatWidget = void 0;
var react_1 = __importDefault(require("react"));
var client_1 = __importDefault(require("react-dom/client"));
var index_1 = __importDefault(require("./components/ChatWidget/index"));
var config_1 = __importDefault(require("./constants/config"));
// Create and export a global function to render the widget for embedding purposes
var initializeChatWidget = function () {
    console.log('Initializing chat widget...');
    var div = document.createElement('div');
    div.id = config_1.default.divId;
    div.style.position = 'fixed';
    div.style.bottom = '20px';
    div.style.right = '20px';
    div.style.zIndex = '1000';
    document.body.appendChild(div);
    // For React 18+, use createRoot instead of ReactDOM.render
    var root = client_1.default.createRoot(div);
    root.render(react_1.default.createElement(index_1.default, null));
};
exports.initializeChatWidget = initializeChatWidget;
if (typeof window !== 'undefined') {
    window.onload = function () {
        console.log('Window loaded, initializing widget...');
        (0, exports.initializeChatWidget)();
    };
}
